import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../../templates/landing/kun.jsx';
import CreditCardsModel from '../../models/creditCards.m';
import {apiback} from '../../../../config';
import widgetsHelper from 'utils/getWidget.helper';

const universalCard = 'universal_card';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            model: {},
            mode: 'info',
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: []
        };

        this.crefs = {};

        this.toggleTariffMode = this.toggleTariffMode.bind(this);
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    toggleTariffMode() {
        this.setState(prevState => ({
            fullTariffMode: !prevState.fullTariffMode
        }));
    }

    toggleMode = mode => {
        this.setState({mode: mode});
    };

    componentWillMount() {
        this.widgetsHelper.getWidgets.call(this);
        fetch(apiback('CREDIT_CARDS'))
            .then(res => res.json())
            .then(json =>
                this.setState({
                    model: new CreditCardsModel(json.data[universalCard])
                })
            );
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    }

    static displayName = 'CardUniversal';

    static contextTypes = {
        app: PropTypes.object,
        history: PropTypes.object
    };
}
